<template>
  <div>
    <div>
      <strong class="common-text-item" v-text="`玩家总输赢：${integraTotal/100} 金豆`"></strong>
      <strong class="common-text-item" v-text="`玩家总服务费：${feeTotal/100} 金豆`"></strong>
      <strong class="common-text-item" v-text="`总赔付玩家：${insuranceExpenditureTotal/100} 金豆`"></strong>
      <strong class="common-text-item" v-text="`玩家第一次投入保险：${insuranceProfitOneTotal/100} 金豆`"></strong>
      <strong class="common-text-item" v-text="`玩家第二次投入保险：${insuranceProfitTowTotal/100} 金豆`"></strong>
    </div>
    <div class="common-header">
      <div class="common-header-right">
        <div class="common-header-block">
        <el-input
            class="common-el-input"
            placeholder="输入用户ID查询"
            v-model="roomId"
            type="number"
            clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="getList()">搜索</el-button>
      </div>
      </div>
    </div>
      <div class="common-header">
        <div class="common-header-left">
          <el-radio-group class="common-el-radio-group" v-model="type" @change="getList()">
            <el-radio-button label="21">短牌</el-radio-button>
            <el-radio-button label="61">德州</el-radio-button>
            <el-radio-button label="91">奥马哈</el-radio-button>
            <el-radio-button label="63">aof德州</el-radio-button>
            <el-radio-button label="93">aof奥马哈</el-radio-button>
            <el-radio-button label="23">aof短牌</el-radio-button>
            <el-radio-button label="1001">德州牛仔</el-radio-button>
            <el-radio-button label="1002">百人德州</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    <div class="common-table">
      <el-table v-loading="loading" :data="filterList" height="100%" row-key="id">
        <el-table-column label="用户名称" align="center" prop="userName"/>
        <el-table-column label="房间ID/房间名称/房间类型" width="200" align="center">
          <template slot-scope="scope">{{scope.row.roomId}} / {{scope.row.roomName}} /
            {{clubRoomTypeVal(scope.row.clubRoomType)}}</template>
        </el-table-column>
        <el-table-column v-if="!shortCardShow(type)" label="盲注" align="center" >
          <template slot-scope="scope">{{scope.row.mangzhu|blindNoteNumber2}}</template>
        </el-table-column>
        <el-table-column label="玩家下注" align="center">
          <template slot-scope="scope">{{scope.row.xiazhu|numberChip}}</template>
        </el-table-column>
        <el-table-column label="玩家输赢" align="center">
          <template slot-scope="scope">{{scope.row.integral|numberChip}}</template>
        </el-table-column>
        <el-table-column label="俱乐部/联盟/平台输赢" width="180" align="center">
          <template slot-scope="scope">{{scope.row.clubWin|numberChip}} /
            {{scope.row.rebateWin|numberChip}} / {{scope.row.adminWin|numberChip}}</template>
        </el-table-column>
        <el-table-column label="抽水" align="center">
          <template slot-scope="scope">{{scope.row.taxChip|numberChip}}</template>
        </el-table-column>
        <el-table-column label="保险池收益" width="100" align="center">
          <template slot-scope="scope">{{scope.row.insuranceExpenditure | numberChip}}</template>
        </el-table-column>
        <el-table-column label="第一次/二次投入保险" width="150" align="center">
          <template slot-scope="scope">{{scope.row.insuranceProfitOne|numberChip}} / {{scope.row.insuranceProfitTow|numberChip}}</template>
        </el-table-column>
        <el-table-column label="俱乐部/联盟保险获利" width="150" align="center">
          <template slot-scope="scope">{{scope.row.clubInsurance|numberChip}} / {{scope.row.tribeInsurance|numberChip}}</template>
        </el-table-column>
        <el-table-column label="服务费" align="center">
          <template slot-scope="scope">{{scope.row.fee|numberChip}}</template>
        </el-table-column>
        <el-table-column label="俱乐部/联盟返利服务费" width="150" align="center">
          <template slot-scope="scope">{{scope.row.feeClub|numberChip}} / {{scope.row.feeTribe|numberChip}}</template>
        </el-table-column>
        <el-table-column label="中彩值" align="center">
          <template slot-scope="scope">{{scope.row.jp|numberChip}}</template>
        </el-table-column>
        <el-table-column label="彩金服务费" align="center">
          <template slot-scope="scope">{{scope.row.jpFee|numberChip}}</template>
        </el-table-column>
        <el-table-column label="俱乐部/联盟获取彩金服务费" width="150" align="center">
          <template slot-scope="scope">{{scope.row.jpFeeClub|numberChip}} / {{scope.row.jpFeeTribe|numberChip}}</template>
        </el-table-column>
        <el-table-column label="玩家贡献彩池" align="center">
          <template slot-scope="scope">{{getContributionPool(scope.row.sign)}}</template>
        </el-table-column>
        <el-table-column label="贡献彩池总额" align="center">
          <template slot-scope="scope">{{scope.row.contribution|numberChip}}</template>
        </el-table-column>
        <el-table-column label="手数" align="center">
          <template slot-scope="scope">第 {{scope.row.version}} 手</template>
        </el-table-column>
        <el-table-column label="创建时间" align="center">
          <template slot-scope="scope">{{getLocalTime(scope.row.createTime)}}</template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
        class="common-el-pagination"
        layout="prev,pager,next,jumper"
        background
        :page-size="20"
        :pager-count="5"
        :total="total"
        :current-page="currentPage"
        @current-change="getList({page:$event})"/>
  </div>

</template>
<script>
import {mapState, mapActions} from 'vuex'
import {mobileCountryCodeOptions} from 'mixins'

export default {
  mixins: [mobileCountryCodeOptions],
  data() {
    return {
      loading: false,
      userId:0,
      roomId:null,
      total: 0,
      type:61,
      integraTotal:0,
      feeTotal:0,
      insuranceExpenditureTotal:0,
      insuranceProfitOneTotal:0,
      insuranceProfitTowTotal:0,
      integras:[],
      currentPage: 1
    }
  },
  computed: {
    ...mapState('login', ['permissions']),
    filterList() {
      return this.integras;
    }
  },
  created() {
    this.userId = this.$route.params.id;
    this.getList()
  },
  methods: {
    ...mapActions('integral', ['getintegralUserOne']),
    getList(obj = {}) {
      this.loading = true;
      let params = {
        roomId:this.roomId,
        userId:this.userId,
        type:this.type,
        page: 1
      };
      Object.assign(params, obj);
      this.currentPage = params.page;
      this.getintegralUserOne(params).then(res => {
        this.loading = false;
        this.integras=res.data.beanList;
        this.total=res.data.total;
        this.integraTotal=res.data.integraTotal;
        this.feeTotal=res.data.feeTotal;
        this.insuranceExpenditureTotal=res.data.insuranceExpenditureTotal;
        this.insuranceProfitOneTotal=res.data.insuranceProfitOneTotal;
        this.insuranceProfitTowTotal=res.data.insuranceProfitTowTotal;
      })
    },
    numberChip(val){
      return val/100;
    },
    shortCardShow(val){
      return val==21 || val==23;
    },
    blindNoteNumber(val){
      const result=val.split("/");
      return result[0]/100+"/"+result[1]/100;
    },
    clubRoomTypeVal(val){
      if (val==0){
        return "大厅房间";
      }else if(val==1){
        return "俱乐部积分房";
      }else {
        return "大厅积分房";
      }
    },
    getLocalTime(nS) {
      //将时间戳（十三位时间搓，也就是带毫秒的时间搓）转换成时间格式
      let date = new Date(nS);
      let year = date.getFullYear();
      let month = date.getMonth()+1;
      let day = date.getDate();
      month = month < 10 ? "0"+month:month;
      day = day < 10 ? "0"+day:day;
      date = year+'-'+month+'-'+day;
      return date;
    },
    getContributionPool(val) {
      var data="";
      switch (val){
        case 1 :
          data="跑马灯池";
          break
        case 3 :
          data="彩金池";
          break
        case 2 :
          data="系统池";
          break
        default :
          data="-";
          break
      }
      return data;
    },

  }
}
</script>
